export const ACTION_TYPES = {
    REQUEST_POSITIONS: 'REQUEST_POSITIONS',
    RECEIVE_POSITIONS: 'RECEIVE_POSITIONS',
    REQUEST_BO_POSITIONS: 'REQUEST_BO_POSITIONS',
    RECEIVE_BO_POSITIONS: 'RECEIVE_BO_POSITIONS',
    REQUEST_PARTNER_OR_PARENT_POSITIONS: 'REQUEST_PARTNER_OR_PARENT_POSITIONS',
    RECEIVE_PARTNER_OR_PARENT_POSITIONS: 'RECEIVE_PARTNER_OR_PARENT_POSITIONS'
};

const initialState = { entities: [], isLoading: false, boPositionEntities : [], partnerOrParentPositionEntities: []};

export const positionActions = {
    requestPositions: (occupationId) => async (dispatch) => {
  
        dispatch({ type: ACTION_TYPES.REQUEST_POSITIONS });

        const url = `api/position?id=${occupationId}`;
        const response = await fetch(url);
        const entities = await response.json();

        dispatch({ type: ACTION_TYPES.RECEIVE_POSITIONS, entities });
    },

    requestBOPositions: (occupationId) => async (dispatch) => {
        dispatch({ type: ACTION_TYPES.REQUEST_BO_POSITIONS });

        const url = `api/position?id=${occupationId}`;
        const response = await fetch(url);
        const entities = await response.json();

        dispatch({ type: ACTION_TYPES.RECEIVE_BO_POSITIONS, entities });
    },

    requestPartnerOrParentPositions: (occupationId) => async (dispatch) => {
        dispatch({ type: ACTION_TYPES.REQUEST_PARTNER_OR_PARENT_POSITIONS });

        const url = `api/position?id=${occupationId}`;
        const response = await fetch(url);
        const entities = await response.json();

        dispatch({ type: ACTION_TYPES.RECEIVE_PARTNER_OR_PARENT_POSITIONS, entities });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case (ACTION_TYPES.REQUEST_POSITIONS):
            return {
                ...state,
                isLoading: true
            };
        case (ACTION_TYPES.RECEIVE_POSITIONS):
            return {
                ...state,
                isLoading: false,
                entities: action.entities
            };
        case (ACTION_TYPES.REQUEST_BO_POSITIONS):
            return {
                ...state,
                isLoading: true
            };
        case (ACTION_TYPES.RECEIVE_BO_POSITIONS):
            return {
                ...state,
                isLoading: false,
                boPositionEntities: action.entities
            };
        case (ACTION_TYPES.REQUEST_PARTNER_OR_PARENT_POSITIONS):
            return {
                ...state,
                isLoading: true
            };
        case (ACTION_TYPES.RECEIVE_PARTNER_OR_PARENT_POSITIONS):
            return {
                ...state,
                isLoading: false,
                partnerOrParentPositionEntities: action.entities
            };
        default:
            return state;
    }

};



// WEBPACK FOOTER //
// ./src/store/Position.Reducer.js